import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    name: 'M. R.',
    text: 'La tranquilidad que siento ahora no tiene precio. El sistema paso a paso me dio la confianza que había perdido hace años.',
    focus: 'Tranquilidad y Confianza'
  }, {
    name: 'J. P.',
    text: 'Lo mejor es la privacidad. Nadie se enteró y pude ver progreso real semana a semana. El protocolo del primer encuentro es oro puro.',
    focus: 'Privacidad y Progreso'
  }, {
    name: 'A. G.',
    text: 'Volví a disfrutar sin estar pensando todo el tiempo en el reloj. Es una transformación total de mentalidad y control.',
    focus: 'Sensación de Control'
  }];
  return <section className="py-24 bg-black relative" data-id="element-108">
      <div className="absolute inset-0 bg-red-glow opacity-20" data-id="element-109"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-110">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-111">
          <h2 className="text-5xl md:text-6xl font-teko font-bold text-white mb-4" data-id="element-112">
            HOMBRES QUE DECIDIERON{' '}
            <span className="text-intense-red text-glow-red" data-id="element-113">
              RECUPERAR EL CONTROL
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-114">
          {testimonials.map((t, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.2
        }} className="bg-panel-bg border border-white/10 p-8 rounded-2xl relative group hover:border-electric-blue/50 transition-colors" data-id="element-115">
              <div className="flex gap-1 mb-6" data-id="element-116">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-electric-blue text-electric-blue" data-id="element-117" />)}
              </div>

              <p className="text-xl text-gray-300 font-medium mb-8 italic leading-relaxed" data-id="element-118">
                "{t.text}"
              </p>

              <div className="mt-auto border-t border-white/10 pt-6 flex justify-between items-center" data-id="element-119">
                <span className="text-gray-500 font-bold text-sm" data-id="element-120">
                  {t.name}
                </span>
                <span className="text-electric-blue text-xs font-bold uppercase tracking-wider bg-electric-blue/10 px-3 py-1 rounded-full" data-id="element-121">
                  {t.focus}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}